import { ClientErrorRequest } from "@lifeat/shared/system/ClientErrorTypes";
import { functions } from "@firebase-local/firebase";
import { CLIENT_ERROR_FUNCTIONS } from "@firebase-local/functions/ServerlessEndpoints";

export function logClientError(error: Error) {
    const buildClientErrorRequest = (error: Error): ClientErrorRequest => {
        return {
            message: error.message,
            stackTrace: error.stack,
        };
    };

    functions.httpsCallable(CLIENT_ERROR_FUNCTIONS.LogClientError)(buildClientErrorRequest(error));
}

export function logClientErrorMessage(message: string) {
    const payload: ClientErrorRequest = {
        message: message,
        stackTrace: undefined,
    };
    functions.httpsCallable(CLIENT_ERROR_FUNCTIONS.LogClientError)(payload);
}
